import React from 'react';

const CustomLine = ({ color = '#7C517E' }) => {
  return (
    <div className="relative w-[40px] flex justify-center">
      <div className="w-full h-[2px] mb-2 sm:mb-0 lg:mb-0" style={{ backgroundColor: color }}></div>
      <div
        className="absolute w-[4px] h-[2px] bg-[#7C517E] top-0 left-1/2 transform -translate-x-1/2"
        style={{ backgroundColor: color }}
      ></div>
    </div>
  );
};

export default CustomLine;
